'use strict';

exports.__esModule = true;

var _core = require('@emotion/core');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return 'You have tried to stringify object returned from `css` function. It isn\'t supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).'; } /** @jsxRuntime classic */ /** @jsx jsx */

var highlightedStyling = process.env.NODE_ENV === 'production' ? {
	name: '12fugvv-highlightedStyling',
	styles: 'overflow:hidden;text-overflow:ellipsis;white-space:nowrap;.highlight{font-weight:600;padding:0;background-color:transparent;color:inherit;};label:highlightedStyling;'
} : {
	name: '12fugvv-highlightedStyling',
	styles: 'overflow:hidden;text-overflow:ellipsis;white-space:nowrap;.highlight{font-weight:600;padding:0;background-color:transparent;color:inherit;};label:highlightedStyling;',
	map: '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */',
	toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var Highlight = function Highlight(props) {
	var textToHighlight = props.textToHighlight,
	    searchWords = props.searchWords,
	    autoEscape = props.autoEscape,
	    hasPredictiveSuggestion = props.hasPredictiveSuggestion,
	    categoryLabel = props.categoryLabel;

	var modSearchWords = searchWords.map(function (word) {
		return autoEscape ? (0, _utils.escapeRegExp)(word) : word;
	}).filter(function (word) {
		return word;
	});
	var stringToReplace = categoryLabel || modSearchWords.join('|');
	return (0, _core.jsx)('div', {
		css: highlightedStyling,
		dangerouslySetInnerHTML: {
			__html: hasPredictiveSuggestion ? textToHighlight : textToHighlight.replace(new RegExp(stringToReplace, 'ig'), function (matched) {
				return '<mark class="highlight">' + matched + '</mark>';
			})
		}
	});
};

Highlight.propTypes = {
	searchWords: _propTypes2.default.arrayOf(_propTypes2.default.string),
	textToHighlight: _propTypes2.default.string,
	autoEscape: _propTypes2.default.bool,
	hasPredictiveSuggestion: _propTypes2.default.bool,
	categoryLabel: _propTypes2.default.string
};

Highlight.defaultProps = {
	searchWords: [],
	textToHighlight: '',
	autoEscape: false,
	hasPredictiveSuggestion: false
};

exports.default = Highlight;